import Draggable from "react-draggable";
import LiveOrderStats from "../LiveOrderStats";

export function MovableLiveStatus() {
  return (
    <Draggable>
      <div className="fixed top-[110px] right-[450px] z-40 shadow-lg border rounded-md bg-white cursor-move">
        <LiveOrderStats />
      </div>
    </Draggable>
  );
}
